<template>
    <div class="item_list">
        <div class="item" :class="{selected: checkSelected(item)}"
             @click="selectItem(item)"
             v-for="item in item_list"
             :key="item.name"
        >
            <p class="image"><img :src="getPath(item)" :alt="item.name"></p>
            <p class="text">{{item.name}}</p>
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import CONST from '../../../assets/js/const'

    export default {
        name: "ItemList",
        props: {
            item_type: {
                type: String,
                required: true
            },
            editing_item: {
                type: Object,
                required: true
            }
        },
        data: () => ({
            img_base_url: `${process.env.VUE_APP_BASE_URL}item_image`,
        }),
        computed: {
            ...mapState('item_data', ["curtain_data", "wall_data", "floor_data", ]),
            item_list: _this => {
                switch (_this.item_type) {
                    case CONST.ITEM_TYPE_CURTAIN: {
                        return _this.curtain_data;
                    }
                    case CONST.ITEM_TYPE_WALL: {
                        return _this.wall_data;
                    }
                    case CONST.ITEM_TYPE_FLOOR: {
                        return _this.floor_data;
                    }
                }
            },
        },
        methods: {
            getPath(item_data) {
                if (!item_data.name) return './assets/images/unnamed.png';
                return `${this.img_base_url}/${this.item_type}/thumbnail/${item_data.name}.jpg?version=2.0`
            },
            selectItem(item_data) {
                this.$emit('select_item', item_data)
            },
            checkSelected(item) {
                if (!this.editing_item) return false;
                return item.name === (this.editing_item.item_data && this.editing_item.item_data.name)
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../assets/css/define";
    *{ margin: 0 }

    .item_list{
        padding: 1rem 0;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .item{
            @extend .clickable;
            position: relative;
            width: calc((100% / 4) - 0.5rem);
            background-color: #F2F2F2;
            margin-bottom: 1rem;
            img{
                width: 100%;
                vertical-align: middle;
            }
            .text{
                text-align: center;
                padding: 0.3rem 0;
            }
            &.selected:before{
                content: '';
                position: absolute;
                border: 3px solid #6EE1B9;
                top: 0;
                right: 0;
                left: 0;
                bottom: 0;
            }
        }
    }

</style>
